import { on } from 'js/lib/events'
import { createAnalyticsGroup } from 'js/lib/analytics'

const track = createAnalyticsGroup('popups')

on('click', '.js-c-popups--join-member-facebook .js-facebook--button', () => {
  track('join', 'facebook-popup')
})

on('click', '.js-c-popups--join-member-facebook .js-c-popups--join-member-facebook--later', () => {
  $.ajax({
    url: document.querySelector('.js-c-popups--join-member-facebook').dataset.remindLaterUrl,
    success: function () {
      document.querySelector('.js-c-popups--join-member-facebook.js-c-footer-popup').style.display = 'none'
    },
  })

  track('join-later', 'facebook-popup')
})

on('click', '.js-c-popups--join-member-facebook .js-c-footer-popup__close', () => {
  $.ajax({
    url: document.querySelector('.js-c-popups--join-member-facebook').dataset.remindLaterUrl,
    data: {
      session: true
    }
  })

  track('close', 'facebook-popup')
})
